module.exports = __webpack_public_path__ + "static/media/ecommerce.553bf6d3.png";